// FlashcardRating.jsx

import React from "react";
import "./Flashcards.css"; // Uses the same pill styles



/**
 * FlashcardRating renders 4 pill buttons that update the flashcard's SM-2 stats in Firestore.
 *
 * @param {string} userId - current user
 * @param {string} classId - current class
 * @param {string} unitId - current unit
 * @param {string} flashcardId - current flashcard
 */
const FlashcardRating = ({ onRate }) => {
  return (
    <div className="flashcard-rating">
      <button className="pill-btn" onClick={() => onRate(0)}>Horrible</button>
      <button className="pill-btn" onClick={() => onRate(2)}>Ok</button>
      <button className="pill-btn" onClick={() => onRate(4)}>Good</button>
      <button className="pill-btn" onClick={() => onRate(5)}>Perfect</button>
    </div>
  );
};


export default FlashcardRating;
